import {
  ColorSchemeScript,
  MantineProvider,
  createTheme,
  mantineHtmlProps,
} from '@mantine/core';
import {
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
  isRouteErrorResponse,
} from 'react-router';
import type { Route } from './+types/root';
import '@mantine/core/styles.css';
import stylesheet from './app.css?url';

const theme = createTheme({
  colors: {
    // https://mantine.dev/colors-generator/?color=172b60
    primary: [
      '#eff2fb',
      '#dbe1f0',
      '#b2c0e4',
      '#889cd8',
      '#647fce',
      '#4e6cc9',
      '#4262c7',
      '#3552b0',
      '#2d499e',
      '#172b60',
    ],
  },
  primaryColor: 'primary',
});

export const meta: Route.MetaFunction = () => [{ title: 'LINE連携ログイン' }];

export const links: Route.LinksFunction = () => [
  { rel: 'stylesheet', href: stylesheet },
];

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <html lang="ja" {...mantineHtmlProps}>
      <head>
        <meta charSet="utf-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1"
        />
        <meta name="robots" content="noindex,nofollow" />
        <ColorSchemeScript />
        <Meta />
        <Links />
      </head>
      <body>
        <MantineProvider theme={theme}>{children}</MantineProvider>
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
}

export default function App() {
  return <Outlet />;
}

export function HydrateFallback() {
  return (
    <div
      className="flex min-h-screen items-center justify-center"
      aria-label="読み込み中"
    >
      <div className="size-5 animate-ping rounded-full bg-primary" />
    </div>
  );
}

export function ErrorBoundary({ error }: Route.ErrorBoundaryProps) {
  let stack: string | undefined;

  if (isRouteErrorResponse(error)) {
    // 必要に応じてエラーハンドリング error: ErrorResponse
  } else if (import.meta.env.DEV && error && error instanceof Error) {
    stack = error.stack;
  }

  return (
    <main className="container mx-auto p-4 pt-16">
      <div className="text-center">
        <h1 className="mb-10 text-center font-bold text-2xl">
          エラーが発生しました
        </h1>
        <p>アプリケーションを再起動してください</p>
      </div>

      {stack && (
        <pre className="mt-16 w-full overflow-x-auto p-4 text-xs">
          <code>{stack}</code>
        </pre>
      )}
    </main>
  );
}
